export default __webpack_public_path__ + "static/media/SAL3.8bb4900f.jpg";